// extracted by mini-css-extract-plugin
export default {"voiceButton":"voiceButton---V92G4","listening":"listening---utI5_","pulse":"pulse---rQ1qF","error":"error---KYWKJ","notSupported":"notSupported---QoE4L"};